<div class="content">

  <form #leadForm="ngForm" (ngSubmit)="saveProject(leadForm)">
    <div class="container float-left">
      <div class="row">
        <p class="col-sm-9">
          <span *ngIf="project.quote_IsLead" i18n>
            Provide lead information below.  Please note: leads must have an established customer set up to add a lead.
          </span>
          <span *ngIf="project.quote_IsLead==false" i18n>
            Provide quote information below.  Please note: quotes must have an established customer set up to add a quote.
          </span>
        </p>
        <p class="col-sm-3 warning" i18n>* Required Information</p>
      </div>

      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div *ngIf="project.quote_ID==null" class="control-wrapper">
            <span class="warning">* </span>
            <label for="customer_BusinessName" i18n>Customer Name</label>
            <input type="text" name="customer_BusinessName" id="customer_BusinessName"
                   class="form-control"
                   autocomplete="nope"
                   required=""
                   matInput
                   [formControl]="customerControl"
                   [matAutocomplete]="customerAuto"
                   [attr.disabled]="readOnly ? '' : null" />
            <mat-autocomplete autoActiveFirstOption #customerAuto="matAutocomplete">
              <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer.customer_BusinessName">{{customer.customer_BusinessName}}</mat-option>
            </mat-autocomplete>
            <div [hidden]="!leadForm.submitted || customerControl.valid"
                 class="alert alert-danger" i18n>Customer Required</div>
          </div>
          <div *ngIf="project.quote_ID" class="control-wrapper">
            <span class="warning">* </span>
            <label for="customer_BusinessName" i18n>Customer Name</label>
            <select name="customer_ID" id="customer_ID"
                    class="form-control select-bidit"
                    required=""
                    [attr.disabled]="readOnly ? '' : null"
                    (change)="refreshCustomer()"
                    [(ngModel)]="project.customer_ID" #customer_ID="ngModel">
              <option *ngFor="let customer of customers" [value]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
            </select>
            <div [hidden]="!leadForm.submitted || customerControl.valid"
                 class="alert alert-danger" i18n>Customer Required</div>
          </div>
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label for="customerType_ID" i18n>Customer Type</label>
            <select name="customerType_ID" id="customerType_ID"
                    required
                    [attr.disabled]="readOnly ? '' : null"
                    class="form-control select-bidit"
                    [(ngModel)]="project.customer.customerType_ID" #customerType_ID="ngModel">
                <option [ngValue]="undefined">-</option>
              <option *ngFor="let customerType of customerTypes" [ngValue]="customerType.customerType_ID">{{customerType.customerType_Desc}}</option>
            </select>
            <div [hidden]="!leadForm.submitted || customerType_ID.valid"
                 class="alert alert-danger" i18n>Enter a customer type</div>
          </div>
        </div>
      </div>
      <div *ngIf="project.quote_IsLead==false">
        <div *ngIf="project.quote_ID==null" class="form-group row">
          <div class="col-sm-12 form-inline">
            <div class="control-wrapper">
              <label for="quoteTemplateID" class="col-form-label" i18n>Use Template</label>
              <select name="quoteTemplateID" id="quoteTemplateID" type="text"
                      class="form-control select-bidit"
                      [attr.disabled]="readOnly ? '' : null"
                      maxlength="50"
                      [(ngModel)]="project.quoteTemplateID" #quoteTemplateID="ngModel">
                  <option [ngValue]="undefined">-</option>
                <option *ngFor="let quoteTemplate of quoteTemplates" [ngValue]="quoteTemplate.quote_ID">{{quoteTemplate.quote_Name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_ID" class="col-sm-2 col-form-label" i18n>Customer Address</label>
        <div class="col-sm-10">
          <div *ngIf="project.quote_IsLead">
            <table class="table table-bidit">
              <thead>
                <tr>
                  <td i18n>Address</td>
                  <td i18n>Address (2)</td>
                  <td i18n>City</td>
                  <td i18n>State</td>
                  <td i18n>Zip</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="text" name="customer_Address1" id="customer_Address1" class="form-control"
                           [attr.disabled]="readOnly ? '' : null"
                           [(ngModel)]="project.customer.customer_Address1" #customer_Address1="ngModel" />
                  </td>
                  <td>
                    <input type="text" name="customer_Address2" id="customer_Address2" class="form-control"
                           [attr.disabled]="readOnly ? '' : null"
                           [(ngModel)]="project.customer.customer_Address2" #customer_Address2="ngModel" />
                  </td>
                  <td>
                    <input type="text" name="customer_City" id="customer_City" class="form-control"
                           [attr.disabled]="readOnly ? '' : null"
                           [(ngModel)]="project.customer.customer_City" #customer_City="ngModel" />
                  </td>
                  <td>
                    <select name="customer_State" id="customer_State" class="form-control state-select select-bidit"
                            [attr.disabled]="readOnly ? '' : null"
                            [(ngModel)]="project.customer.customer_State" #customer_State="ngModel">
                      <option value="">-</option>
                      <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
                    </select>
                  </td>
                  <td>
                    <input type="text" name="customer_Postal" id="customer_Postal" class="form-control"
                           [attr.disabled]="readOnly ? '' : null"
                           [(ngModel)]="project.customer.customer_Postal" #customer_Postal="ngModel" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="!project.quote_IsLead">
            <table class="table table-bidit">
              <thead>
                <tr>
                  <td i18n>Address</td>
                  <td i18n>Address (2)</td>
                  <td i18n>City</td>
                  <td i18n>State</td>
                  <td i18n>Zip</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span class="warning">* </span>
                    <input type="text" name="customer_Address1" id="customer_Quote_Address1"
                           class="form-control float-right" style="width: 95%;"
                           [attr.disabled]="readOnly ? '' : null"
                           required=""
                           [(ngModel)]="project.customer.customer_Address1" #customer_Address1="ngModel" />
                  </td>
                  <td>
                    <input type="text" name="customer_Address2" id="customer_Address2"
                           class="form-control"
                           [attr.disabled]="readOnly ? '' : null"
                           [(ngModel)]="project.customer.customer_Address2" #customer_Address2="ngModel" />
                  </td>
                  <td>
                    <span class="warning">* </span>
                    <input type="text" name="customer_City" id="customer_City"
                           class="form-control float-right" style="width: 95%;"
                           [attr.disabled]="readOnly ? '' : null"
                           required=""
                           [(ngModel)]="project.customer.customer_City" #customer_City="ngModel" />
                  </td>
                  <td style="width: 115px;">
                    <span class="warning">* </span>
                    <select name="customer_State" id="customer_State"
                            class="form-control state-select select-bidit float-right"
                            [attr.disabled]="readOnly ? '' : null"
                            required=""
                            [(ngModel)]="project.customer.customer_State" #customer_State="ngModel">
                      <option value="">-</option>
                      <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
                    </select>
                  </td>
                  <td>
                    <span class="warning">* </span>
                    <input type="text" name="customer_Postal" id="customer_Postal"
                           class="form-control float-right" style="width: 95%;"
                           [attr.disabled]="readOnly ? '' : null"
                           required=""
                           [(ngModel)]="project.customer.customer_Postal" #customer_Postal="ngModel" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div [hidden]="!leadForm.submitted || (customer_Address1.valid && customer_City.valid && customer_State.valid && customer_Postal.valid)"
                 class="alert alert-danger" i18n>Customer Address Required</div>
          </div>

        </div>
      </div>
      <div class="form-group row">
        <label for="customer_ID" class="col-sm-2 col-form-label" i18n>Contact</label>
        <div class="col-sm-10">

          <select *ngIf="customer" name="contact_ID" id="contact_ID"
              class="form-control select-bidit mb-1"
              (change)="onContactChange()"
              required=""
              [attr.disabled]="readOnly ? '' : null"
              [(ngModel)]="project.contact_ID" #contact_ID="ngModel">
            <option *ngFor="let contact of customer.contacts" [value]="contact.contact_ID">{{contact.contact_FirstName}} {{contact.contact_LastName}}</option>
          </select>

          <table class="table table-bidit">
            <thead>
              <tr>
                <td i18n>Contact First Name</td>
                <td i18n>Contact Last Name</td>
                <td i18n>Phone #</td>
                <td i18n>Cell #</td>
                <td i18n>Email</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="warning">* </span>
                  <input type="text" name="contact_FirstName" id="contact_FirstName"
                         required=""
                         class="form-control float-right" style="width: 95%;"
                         [attr.disabled]="readOnly ? '' : null"
                         [(ngModel)]="project.customer.contact_FirstName" #contact_FirstName="ngModel" />
                </td>
                <td>
                  <span class="warning">* </span>
                  <input type="text" name="contact_LastName" id="contact_LastName"
                         class="form-control float-right" style="width: 95%;"
                         required=""
                         [attr.disabled]="readOnly ? '' : null"
                         [(ngModel)]="project.customer.contact_LastName" #contact_LastName="ngModel" />
                </td>
                <td>
                  <input type="text" name="contact_Phone" id="contact_Phone"
                         class="form-control float-right" style="width: 95%;"
                         placeholder="(999) 999-9999" appPhoneMask
                         [attr.disabled]="readOnly ? '' : null"
                         [(ngModel)]="project.customer.contact_Phone" #contact_Phone="ngModel" />
                </td>
                <td>
                  <input type="text" name="contact_Mobile" id="contact_Mobile"
                         class="form-control float-right" style="width: 95%;"
                         placeholder="(999) 999-9999" appPhoneMask
                         [attr.disabled]="readOnly ? '' : null"
                         [(ngModel)]="project.customer.contact_Mobile" #contact_Mobile="ngModel" />
                </td>
                <td>
                  <input type="text" name="contact_Email" id="contact_Email"
                         class="form-control float-right" style="width: 95%"
                         [attr.disabled]="readOnly ? '' : null"
                         [(ngModel)]="project.customer.contact_Email" #contact_Email="ngModel" />
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="form-inline control-wrapper">
                    <span class="warning">* </span>
                    <label for="contactType_ID" class="col-form-label" i18n>Contact Type</label>
                    <select name="contactType_ID" id="contactType_ID" class="form-control select-bidit"
                            required
                            [attr.disabled]="readOnly ? '' : null"
                            [(ngModel)]="project.customer.contactType_ID" #contactType_ID="ngModel">
                        <option [ngValue]="undefined">-</option>
                      <option *ngFor="let contactType of contactTypes" [ngValue]="contactType.contactType_ID">{{contactType.contactType_Desc}}</option>
                    </select>
                    <div [hidden]="!leadForm.submitted || contactType_ID.valid"
                         class="alert alert-danger" i18n>Enter a contact type</div>
                  </div>
                </td>
                <td colspan="3">
                  <span class="warning" i18n>* Either Phone #, Cell #, or Email address is required</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div [hidden]="!leadForm.submitted || (contact_FirstName.valid && contact_LastName.valid)"
               class="alert alert-danger" i18n>Contact First and Last Name Required</div>
          <div [hidden]="!leadForm.submitted || ((contact_Phone.value != null && contact_Phone.value != '') ||
                  (contact_Mobile.value != null && contact_Mobile.value != '') ||
                  (contact_Email.value != null && contact_Email.value != ''))"
               class="alert alert-danger" i18n>Contact Phone, Cell, or Email Required</div>
        </div>
      </div>
      <div class="form-group row">
        <label for="customer_ID" class="col-sm-2 col-form-label" i18n>Job Address</label>
        <div class="col-sm-10">
          <span i18n>Same as Customer Address</span>
          <input type="checkbox" name="jobAddressCustom" class="bidit-switch ml-1 mr-1"
                 [attr.disabled]="readOnly ? '' : null"
                 [ngModel]="jobAddressCustom" (click)="onJobAddressCustomChanged($event)" />
          <span i18n>New Job Address</span>
          <div *ngIf="jobAddressCustom">
            <div *ngIf="project.quote_IsLead">
              <table class="table table-bidit">
                <thead>
                  <tr>
                    <td i18n>Address</td>
                    <td i18n>Address (2)</td>
                    <td i18n>City</td>
                    <td i18n>State</td>
                    <td i18n>Zip</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input type="text" name="quote_Address1" id="quote_Address1" class="form-control"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="project.quote_Address1" #quote_Address1="ngModel" />
                    </td>
                    <td>
                      <input type="text" name="quote_Address2" id="quote_Address2" class="form-control"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="project.quote_Address2" #quote_Address2="ngModel" />
                    </td>
                    <td>
                      <input type="text" name="quote_City" id="quote_City" class="form-control"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="project.quote_City" #quote_City="ngModel" />
                    </td>
                    <td>
                      <select name="quote_State" id="quote_State" class="form-control state-select select-bidit"
                              [attr.disabled]="readOnly ? '' : null"
                              [(ngModel)]="project.quote_State" #quote_State="ngModel">
                        <option value="">-</option>
                        <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
                      </select>
                    </td>
                    <td>
                      <input type="text" name="quote_Postal" id="quote_Postal" class="form-control"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="project.quote_Postal" #quote_Postal="ngModel" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="!project.quote_IsLead">
              <table class="table table-bidit">
                <thead>
                  <tr>
                    <td i18n>Address</td>
                    <td i18n>Address (2)</td>
                    <td i18n>City</td>
                    <td i18n>State</td>
                    <td i18n>Zip</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="warning">* </span>
                      <input type="text" name="quote_Address1" id="quote_Address1"
                             class="form-control float-right" style="width: 95%;"
                             [attr.disabled]="readOnly ? '' : null"
                             required=""
                             [(ngModel)]="project.quote_Address1" #quote_Address1="ngModel" />
                    </td>
                    <td>
                      <input type="text" name="quote_Address2" id="quote_Address2"
                             class="form-control"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="project.quote_Address2" #quote_Address2="ngModel" />
                    </td>
                    <td>
                      <span class="warning">* </span>
                      <input type="text" name="quote_City" id="quote_City"
                             class="form-control float-right" style="width: 95%;"
                             [attr.disabled]="readOnly ? '' : null"
                             required=""
                             [(ngModel)]="project.quote_City" #quote_City="ngModel" />
                    </td>
                    <td style="width: 115px;">
                      <span class="warning">* </span>
                      <select name="quote_State" id="quote_State"
                              class="form-control state-select select-bidit float-right"
                              [attr.disabled]="readOnly ? '' : null"
                              required=""
                              [(ngModel)]="project.quote_State" #quote_State="ngModel">
                        <option value="">-</option>
                        <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
                      </select>
                    </td>
                    <td>
                      <span class="warning">* </span>
                      <input type="text" name="quote_Postal" id="quote_Postal"
                             class="form-control float-right" style="width: 95%;"
                             [attr.disabled]="readOnly ? '' : null"
                             required=""
                             [(ngModel)]="project.quote_Postal" #quote_Postal="ngModel" />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div [hidden]="!leadForm.submitted || (quote_Address1.valid && quote_City.valid && quote_State.valid && quote_Postal.valid)"
                   class="alert alert-danger" i18n>Customer Address Required</div>

            </div>

          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label for="quote_AssignedTo" class="col-form-label" i18n>Salesperson</label>
            <mat-select multiple required name="quote_AssignedTo" id="quote_AssignedTo" style="width:200px;" class="form-control"
                    [attr.disabled]="readOnly ? '' : null"
                    [(value)]="project.assignmentEdit">
              <mat-option *ngFor="let salesPerson of salesPersons" [value]="salesPerson.id">{{salesPerson.lastName}}, {{salesPerson.firstName}}</mat-option>
            </mat-select>
            <div [hidden]="!leadForm.submitted || (project.assignmentEdit != null && project.assignmentEdit.length > 0)"
                 class="alert alert-danger" i18n>Salesperson Required</div>
          </div>
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label for="office_ID" class="col-form-label" i18n>Office</label>
            <select name="office_ID" id="office_ID" class="form-control select-bidit"
                    required=""
                    [attr.disabled]="readOnly ? '' : null"
                    [(ngModel)]="project.office_ID" #office_ID="ngModel">

                <option [ngValue]="undefined">-</option>
              <option *ngFor="let office of offices" [ngValue]="office.office_ID">{{office.office_Name}}</option>
            </select>
            <div [hidden]="!leadForm.submitted || office_ID.valid"
                 class="alert alert-danger" i18n>Office Required</div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="hasPlans" i18n>Blueprint Measure Only</label>
            <mat-radio-group area-label="Take off provided" name="blueprintPlans" id="blueprintPlans"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="blueprintPlans">
              <mat-radio-button [disabled]="readOnly" value="true" i18n>Yes</mat-radio-button>
              <mat-radio-button [disabled]="readOnly" value="false" i18n>No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="control-wrapper">
            <label for="planDate" class="col-form-label" i18n>Blueprint Revision Date</label>
            <input name="quote_PlanDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="planPicker"
                   [disabled]="readOnly"
                   [(ngModel)]="project.quote_PlanDate" #quote_PlanDate="ngModel" />
            <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="planPicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="readOnly" #planPicker></mat-datepicker>
          </div>
          <div class="control-wrapper">
            <label for="hasMeasure" class="col-form-label" i18n>Field Measure</label>
            <mat-radio-group area-label="Measure provided" name="fieldMeasure" id="fieldMeasure"
                             [attr.disabled]="readOnly ? '' : null"
                             [(ngModel)]="fieldMeasure">
              <mat-radio-button [disabled]="readOnly" value="true" i18n>Yes</mat-radio-button>
              <mat-radio-button [disabled]="readOnly" value="false" i18n>No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div *ngIf="project.quote_IsLead; else quoteTypeBlock" class="control-wrapper">
            <label for="jobType_ID" class="col-form-label" i18n>Job Type</label>
            <select name="jobType_ID" id="jobType_ID" class="form-control select-bidit"
                    [attr.disabled]="readOnly ? '' : null"
                    [(ngModel)]="project.jobType_ID" #jobType_ID="ngModel">
                <option [ngValue]="undefined">-</option>
              <option *ngFor="let jobType of jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
            </select>
          </div>
          <ng-template #quoteTypeBlock>
            <div class="control-wrapper">
              <span class="warning">* </span>
              <label for="jobType_ID" class="col-form-label" i18n>Job Type</label>
              <select name="jobType_ID" id="jobType_ID" class="form-control select-bidit"
                      [attr.disabled]="readOnly ? '' : null"
                      required=""
                      [(ngModel)]="project.jobType_ID" #jobType_ID="ngModel">
                  <option [ngValue]="undefined">-</option>
                <option *ngFor="let jobType of jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
              </select>
              <div [hidden]="!leadForm.submitted || jobType_ID.valid"
                   class="alert alert-danger" i18n>Job Type Required</div>
            </div>

          </ng-template>
          <div *ngIf="project.quote_IsLead; else quoteReadyBlock" class="control-wrapper">
            <label for="readyDate" class="col-form-label" i18n>Estimated Start Date</label>
            <input name="quote_ReadyDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="readyPicker"
                   [disabled]="readOnly"
                   [(ngModel)]="project.quote_ReadyDate" #quote_ReadyDate="ngModel" />
            <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="readyPicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="readOnly" #readyPicker></mat-datepicker>
          </div>
          <ng-template #quoteReadyBlock>
            <div class="control-wrapper">
              <label for="readyDate" class="col-form-label" i18n>Estimated Start Date</label>
              <input name="quote_ReadyDate" class="form-control narrow-input" matInput
                     placeholder="mm/dd/yyyy"
                     [matDatepicker]="readyPicker"
                     [disabled]="readOnly"
                     [(ngModel)]="project.quote_ReadyDate" #quote_ReadyDate="ngModel" />
              <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="readyPicker"></mat-datepicker-toggle>
              <mat-datepicker [disabled]="readOnly" #readyPicker></mat-datepicker>
            </div>

          </ng-template>
          <div *ngIf="project.quote_IsLead" class="control-wrapper">
            <span class="warning">* </span>
            <label for="quote_Probability" class="col-form-label" i18n>Probability</label>
            <div class="info-icon" i18n-matTooltip matTooltip="Confidence factor for lead"></div>
            <select name="quote_Probability" id="quote_Probability" type="text" class="form-control select-bidit"
                    [attr.disabled]="readOnly ? '' : null"
                    required=""
                    [(ngModel)]="project.quote_Probability" #quote_Probability="ngModel">
              <option value="">-</option>
              <option value="H" i18n>High</option>
              <option value="M" selected i18n>Medium</option>
              <option value="L" i18n>Low</option>
            </select>
            <div [hidden]="!leadForm.submitted || quote_Probability.valid"
                 class="alert alert-danger" i18n>Probability Required</div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label for="quote_Name" class="col-form-label" i18n>Project Name</label>
            <input name="quote_Name" id="quote_Name" type="text" class="form-control"
                   [attr.disabled]="readOnly ? '' : null"
                   maxlength="50" required=""
                   [(ngModel)]="project.quote_Name" #quote_Name="ngModel">
            <div [hidden]="!leadForm.submitted || quote_Name.valid"
                 class="alert alert-danger" i18n>Enter a project name</div>
          </div>
          <div class="control-wrapper">
            <span class="warning">* </span>
            <label for="leadSourceType_ID" class="col-form-label" i18n>Lead Source</label>
            <select name="leadSourceType_ID" id="leadSourceType_ID" class="form-control select-bidit"
                    required=""
                    [attr.disabled]="readOnly ? '' : null"
                    [(ngModel)]="project.leadSourceType_ID" #leadSourceType_ID="ngModel">
                <option [ngValue]="undefined">-</option>
              <option *ngFor="let source of leadSourceTypes" [ngValue]="source.leadSourceType_ID">{{source.leadSourceType_Desc}}</option>
            </select>
            <div [hidden]="!leadForm.submitted || leadSourceType_ID.valid"
                 class="alert alert-danger" i18n>Lead Source Required</div>
          </div>
          <div class="control-wrapper">
            <label for="quote_LeadSourceComments" class="col-form-label" i18n>Lead Source Comments</label>
            <input name="quote_LeadSourceComments" id="quote_LeadSourceComments" class="form-control" type="text"
                   [attr.disabled]="readOnly ? '' : null"
                   [(ngModel)]="project.quote_LeadSourceComments" #quote_LeadSourceComments="ngModel" />
          </div>
          <div *ngIf="project.quote_IsLead" class="control-wrapper">
            <span class="warning">* </span>
            <label for="leadDueDate" class="col-form-label" i18n>Lead Expiration Date</label>
            <div class="info-icon" i18n-matTooltip matTooltip="Date which lead must be resolved by"></div>
            <input name="quote_LeadDueDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="dueDatePicker"
                   required=""
                   [disabled]="readOnly"
                   [(ngModel)]="project.quote_LeadDueDate" #quote_LeadDueDate="ngModel" />
            <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="readOnly" #dueDatePicker></mat-datepicker>
            <div [hidden]="!leadForm.submitted || quote_LeadDueDate.valid"
                 class="alert alert-danger" i18n>Lead expiration Required</div>
          </div>
          <div *ngIf="project.quote_IsLead" class="control-wrapper">
            <label for="followUpReminder" class="col-form-label" i18n>Follow Up Reminder Date</label>
            <div class="info-icon" i18n-matTooltip matTooltip="Date which a reminder will be sent to assigned salesperson"></div>
            <input name="quote_FollowUpReminder" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="followUpReminderPicker"
                   [disabled]="readOnly"
                   [(ngModel)]="project.quote_FollowUpReminder" #quote_FollowUpReminder="ngModel" />
            <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="followUpReminderPicker"></mat-datepicker-toggle>
            <mat-datepicker [disabled]="readOnly" #followUpReminderPicker></mat-datepicker>
          </div>
        </div>
      </div>
      <div *ngIf="!project.quote_IsLead" class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="quote_PaymentType_ID" class="col-form-label" i18n>Payment Type</label>
            <select name="quote_PaymentType_ID" id="quote_PaymentType_ID" class="form-control select-bidit"
                    [attr.disabled]="readOnly ? '' : null"
                    [(ngModel)]="project.quote_PaymentType_ID" #quote_PaymentType_ID="ngModel">

                <option [ngValue]="undefined">-</option>
              <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType.paymentType_ID">{{paymentType.paymentType_Desc}}</option>
            </select>
          </div>
          <div class="control-wrapper">
            <label for="quote_PaymentTerm_ID" class="col-form-label" i18n>Payment Terms</label>
            <select name="quote_PaymentTerm_ID" id="quote_PaymentTerm_ID" class="form-control select-bidit"
                    [attr.disabled]="readOnly ? '' : null"
                    [(ngModel)]="project.quote_PaymentTerm_ID" #quote_PaymentTerm_ID="ngModel">

                <option [ngValue]="undefined">-</option>
              <option *ngFor="let paymentTerm of paymentTerms" [ngValue]="paymentTerm.paymentTerm_ID">{{paymentTerm.paymentTerm_Desc}}</option>
            </select>
          </div>
        </div>
      </div>
      <div *ngIf="readOnly == false" class="row">
        <div class="col-md-12">
          <div align="right">
            <button type="submit" name="submit" id="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
            <button type="button" class="btn btn-bidit-cancel" (click)="cancelEdit()" i18n>Cancel</button>
            <div [hidden]="!leadForm.submitted || leadForm.valid"
                 class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>
